jQuery( function jsScroll($){

    $('body').on('click', '.js-scroll', scrollFn);
    var $window = $(window);

    function scrollFn(e){
        var $this = $(this);
        var $target = $($this.data('target'));
        var $acc_btn = $($this.data('acc'));
        var margin_top = $('.js-site-header').innerHeight();

        if ($target.length) {
            if ($acc_btn.length){
                setTimeout(function(){
                    $('body, html').stop().animate({
                        scrollTop: parseInt( $target.offset().top - (margin_top + 20) )
                    }, 500, function (){
                        $window.trigger('js-scroll.end')
                    });
                }, 600);
            }else{
                $('body, html').stop().animate({
                    scrollTop: parseInt( $target.offset().top - margin_top )
                }, 500, function (){
                    $window.trigger('js-scroll.end')
                });
            }

        }
        // e.preventDefault();
    }
});
